<template>
    <div  v-if="srcImage" class="image round"  :style="`border: solid ${borderSize}px ${borderColor};`">
        <img  class="round" :src="srcImage" alt="">
    </div>
</template>

<script>
export default {
 name:"MainImage",
 props:{
     srcImage:{
         type:String,
         default:"https://t4.ftcdn.net/jpg/03/46/93/61/360_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg"
     },
     borderSize:{
      type:Number,
      required:false,
      default:0
     },
     borderColor:{
         type:String,
         required:false,
         default:"black"
     }
 }
}
</script>

<style lang="scss" scoped>
.image{
  border-radius: 20px;
  border:solid 10px #EAFFFD;
  width: 50%;
  min-width: 150px;
  margin: auto;
  height: auto;
  max-width: 300px;
  box-shadow: 0 5px 10px #00000030; 
}
.image img{
  width: 100%;
 
  height:auto;
}
.round{
  border-radius: 50000px;
}
</style>